export * from './remitos-selector-productos-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-generar-page/remitos-selector-productos-dialog/index.ts